import React from 'react';

interface SpinnerProps {
  size?: number;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 32 }) => {
  return (
    <div style={{
      width: size,
      height: size,
      border: '3px solid rgba(148, 163, 184, 0.15)',
      borderTopColor: 'var(--primary-600)',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    }} />
  );
};

export default Spinner;
